// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ez8k1qDDH52_KQVGYWCI {\n  text-align: right;\n}\n.ez8k1qDDH52_KQVGYWCI > * {\n  margin-right: 24px;\n}\n.ez8k1qDDH52_KQVGYWCI > *:last-child {\n  margin-right: 0;\n}\n", "",{"version":3,"sources":["webpack://./src/features/heritage/StaticRoll.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,kBAAA;AACJ;AACI;EACE,eAAA;AACN","sourcesContent":[".go-back-container {\n  text-align: right;\n\n  & > * {\n    margin-right: 24px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"go-back-container": "ez8k1qDDH52_KQVGYWCI"
};
export default ___CSS_LOADER_EXPORT___;
